// @core/api/endpoints/authn/link_oauth2_account.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LinkOAuth2AccountRequest,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Link OAuth2 account to user
 * Associates an external OAuth2 provider account with the current user. Allows the user to sign in using the external provider in addition to existing methods.
 */
export async function LinkOAuth2Account(
  data: LinkOAuth2AccountRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/external/link`;
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
